const $ = require('jquery');
const _ = require("underscore");
import LookupTable from "../../components/lookupTable/index";
import run from '../../utilities/run';
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";
import render from "../../utilities/render";
import { formateDateUtil } from "../../utilities/general";
import { actionOptions } from "./filter/actionOptions.js";
import { searchDropdown } from "./filter/searchDropdown.js";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { buildExport, prepareDataToSendController, isEdit, doAjax, pushFilterSessionCacheState, retriveCriteriaObjectByOperation, isNew, isDeleteView, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');
let actionList = actionOptions;
const targerSelector = "#appointments-lookup";
const detailLinkHTML = require('../../utilities/filtersutil/html/detailLinkHTML.html');
let statusPillRenderTemplate = require("./html/statusPillsTemplate.html");
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
const modalHtml = require('../../sharedHtml/modal.html');
const cancelAppointmentModalBodyHtml = require('./html/cancelAppointmentModalBody.html');
const optionTemplateHtml = require('../../sharedHtml/linkGroup/optionTemplate.html');

run(targerSelector, (mainEl) => {
    const lookupData = mainEl.data("lookup-data");
    const lookupTable = mainEl.find("#lookup-wrapper");
    let targetObject = "";
    const modalOpts = { backdrop: 'static', show: false };
    const savedViews = mainEl.data("saved-view");
    const generateExportUrl = mainEl.data("export-url");
    const saveViewURL = mainEl.data("save-view-url");
    let exportModal = new buildExport();
    const deleteViewURL = mainEl.data("delete-view-url");
    const shouldCheckCache = mainEl.data("should-check-cache");
    const extraDetailForCacheFromServer = mainEl.data("extra-detail-for-cache-from-server");
    const criteriaObjectFromServer = mainEl.data("filter-criteria-from-server");
    const portletNamespace = mainEl.data("portlet-namespace");
    const filterAppointmentUrl = mainEl.data("appointment-filter-url");
    const viewDetailUrl = mainEl.data("view-detail");
    const cancelAppointmentUrl = mainEl.data("cancel-appointment");
    const cancelResonList = mainEl.data("cancel-reasons");
    const editAppointmentUrl = mainEl.data("edit-appointment");
    const isFacilityUser = mainEl.data("isfacility-user");
    const loggedInUser = mainEl.data("logged-in-user");
    const isBrokerUser = mainEl.data("is-broker-user");
    const isCarrierUser = mainEl.data("is-carrier-user");
    let lookupColumns;

    const merchantCloumns = [
        {
            render: renderActionWrap,
            orderable: false,
            class: 'dtc-action-column',
            title: "Actions"
        },
        {
            data: "appointmentId",
            title: "Appointment ID",
            class: 'dtc-min-width-md',
            render: createDetailLink,
            orderable: false
        },
        {
            data: "appointmentType",
            title: "Appointment Type",
            class: 'dtc-min-width-sm'
        },
        {
            data: "scheduledArrival",
            title: "Scheduled Arrival",
            class: 'dtc-min-width-md'
        },
        {
            data: "status",
            title: "Status",
            render: statusPillRender,
            class: 'dtc-min-width-sm'
        },
        {
            data: "facility",
            title: "Facility",
            class: 'dtc-min-width-sm'
        },
        {
            data: "createdDate",
            title: "Created On",
            class: 'dtc-min-width-md',
            render: formateDateUtil
        },
        {
            data: "createdBy",
            title: "Created By",
            class: 'dtc-min-width-sm'
        },
    ];

    const facilityColumns = [
        {
            render: renderActionWrap,
            orderable: false,
            class: 'dtc-action-column',
            title: "Actions"
        },
        {
            data: "appointmentId",
            title: "Appointment ID",
            class: 'dtc-min-width-md',
            render: createDetailLink,
            orderable: false
        },
        {
            data: "appAppointmentType",
            title: "Appointment Type",
            class: 'dtc-min-width-sm'
        },
        {
            data: "appPreferredArrivalDate",
            title: "Scheduled Arrival",
            class: 'dtc-min-width-md'
        },
        {
            data: "appStatus",
            title: "Status",
            render: statusPillRender,
            class: 'dtc-min-width-sm'
        },
        {
            data: "appRtlId",
            title: "Merchant(s)",
            class: 'dtc-min-width-sm'
        }
    ];

    if(isFacilityUser){
        lookupColumns = facilityColumns;
    }else{
        lookupColumns = merchantCloumns;
    }

    if (shouldCheckCache) {
        targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
    }

    var submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();

    function createDetailLink(data, type, row) {
        let detailPageHTML = render(
            detailLinkHTML, {
                renderURL: viewDetailUrl,
                portletNamespace: portletNamespace,
                id: row.appId,
                idName: "appId",
                displayVal: row.appointmentId
            }
        );
        return detailPageHTML;
    }

    let appointmentLookup = new LookupTable({
        target: lookupTable,
        minWidthClass: "q-min-width-sm-til-md",
        mobileColumns: [
            {
                data: "appointmentId",
                title: "Appointment ID",
                render: createDetailLink
            },
            {
                data: "appointmentType",
                title: "Appointment Type",
                orderable: false,
            },
            {
                data: "createdDate",
                title: "Created On",
                orderable: false,
            },
            {
                data: "status",
                title: "Status",
                orderable: false,
                render: statusPillRender
            }
        ],

        tableSearchInput: {
            // Not required
            // placeholder: 'Custom Search Text'
            value: (targetObject != "" ? targetObject.value[0] : "")

        },
        tableSearchDropdown: {
            selected: (targetObject == "" ? "" : targetObject.key),
            columns: searchDropdown
        },
        savedViews: savedViews,
        bulkSelect: false,
        dataTable: {
            data: lookupData.content,
            columnDefs: [{
                className: "custom-class", targets: [1]
            }],

            order: [
                [4, 'desc'],
            ],
            columns: lookupColumns
        },
        paginationData: lookupData.page,
        filterModal: {
            // REQUIRED: Sets title of modal
            title: "Filter Appointment",
            // REQUIRED: Sets unique part of subtitle string.
            tableType: "appointment"
        },
        onBulkSelectChange: function () {
            selectedRows = appointmentLookup.getBulkSelectedData();
            $("th.dtc-action-column").html(renderActionHeaderWrap());
            if (selectedRows.length >= 2) {
                $(".action-header-btn .base-btn").removeClass('disabled');
            } else {
                $(".action-header-btn .base-btn").addClass('disabled');
            };
        },
        onFetch: function () {
            let currentData = appointmentLookup.generateData();
            appointmentLookup.showLoadingOverlay();
            //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
            if (isOnlyLookupDataUpdate(currentData)) {
                setTimeout(() => {
                    doAjax({ url: filterAppointmentUrl, success: filterSuccessFun, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
                }, SUCCESS_MODAL_TIMEOUT);
            } else if (isNew(currentData)) {
                setTimeout(() => {
                    doAjax({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
                }, SUCCESS_MODAL_TIMEOUT);
            } else if (isEdit(currentData)) {
                setTimeout(() => {
                    doAjax({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
                }, SUCCESS_MODAL_TIMEOUT);
            } else if (isDeleteView(currentData)) {
                setTimeout(() => {
                    doAjax({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: prepareDataToSendController(currentData, portletNamespace) });
                }, SUCCESS_MODAL_TIMEOUT);
            }
        }
    });

    appointmentLookup.init();
    var table = $("#lookup-wrapper .data-table-component").DataTable();

    function renderActionWrap(data, type, row, meta) {
        let newRender;
        let statusTarget = actionList["actions"];
        newRender = render(
            actionCellDropdownTemplate, {
                list: renderActionCellList(statusTarget, data, row),
                index: meta.row
            }
        );
        return newRender;
    };

    function renderActionCellList(list, data, row) {
        let renderedList = _(list).map((appointments) => {
            return render(
                actionCellDropdownItemTemplate, neededActions(data, row, appointments)
            )
        });
        return renderedList.join('');
    };

    function neededActions(data, row, appointments) {
        var action = {};
        let modifiyAppointment= "";
        
        if(loggedInUser == row.userName){
            modifiyAppointment = "true";
        } 
        if (appointments.title === 'Edit Appointment') {
            if (row.status === "Canceled" || (row.appointmentRetailers.length >1 && !isFacilityUser) || (isBrokerUser && modifiyAppointment === "")
                || (isCarrierUser && modifiyAppointment === "")) {
                action = {
                    icon: appointments.icon,
                    title: appointments.title,
                    cls: appointments.cls,
                    disabled: true
                };
            } else {
                action = {
                    icon: appointments.icon,
                    title: appointments.title,
                    cls: appointments.cls,
                    disabled: false
                };
            }
        } else if (appointments.title === 'Cancel Appointment') {
            if (row.status === "Canceled" || row.asns.length > 1 || (row.appointmentRetailers.length >1 && !isFacilityUser) || (isBrokerUser && modifiyAppointment === "")
                || (isCarrierUser && modifiyAppointment === "")) {
                action = {
                    icon: appointments.icon,
                    title: appointments.title,
                    cls: appointments.cls,
                    disabled: true
                };
            } else {
                action = {
                    icon: appointments.icon,
                    title: appointments.title,
                    cls: appointments.cls,
                    disabled: false
                };
            }
        } else {
            action = {
                icon: appointments.icon,
                title: appointments.title,
                cls: appointments.cls,
                disabled: appointments.disabled
            };
        }
        return action;
    };

    function statusPillRender(data, type, row) {
        let newRender;
        let pillClass;
        if (data == "Scheduled") {
            pillClass = "q-pill-white-and-blue";
        } else {
            pillClass = "q-pill-light-grey";
        }
        return newRender = render(
            statusPillRenderTemplate, {
                data,
                pillClass
            }
        );
    }

    function renderActionHeaderWrap() {
        let statusTarget = actionList['all'];
        let newRender;
        let data = "";
        let row = "";
        newRender = render(
            actionHeaderDropdownTemplate, {
                list: renderActionCellList(statusTarget, data, row)
            }
        );
        return newRender;
    };

    function filterSuccessFun(data) {
        let appointment = data.content;
        let page = data.page;
        appointmentLookup.setNewData(appointment);
        appointmentLookup.setPaginationData(page)
        pushFilterSessionCacheState();
        appointmentLookup.hideLoadingOverlay();
        setExportData(appointmentLookup.generateData());
    }

    function errorFun(data) {
        appointmentLookup.hideLoadingOverlay();
    }

    function savedViewSuccess(data) {
        let appointment = data.appointmentLookup.content;
        let page = data.appointmentLookup.page;
        appointmentLookup.setNewData(appointment);
        appointmentLookup.setPaginationData(page);
        appointmentLookup.setNewSavedViewData(data.savedView, "newSavedView");
        pushFilterSessionCacheState();
        appointmentLookup.hideLoadingOverlay();
        setExportData(appointmentLookup.generateData());
    }

    function savedEditViewSuccess(data) {
        let appointment = data.appointmentLookup.content;
        let page = data.appointmentLookup.page;
        appointmentLookup.setNewData(appointment);
        appointmentLookup.setPaginationData(page);
        appointmentLookup.setNewSavedViewData(data.savedView, data.savedView.target);
        pushFilterSessionCacheState();
        appointmentLookup.hideLoadingOverlay();
        setExportData(appointmentLookup.generateData());
    }


    function delteViewScussFun(data) {
        let appointment = data.appointmentLookup.content;
        let page = data.appointmentLookup.page;
        appointmentLookup.removeSavedView(data.target);
        appointmentLookup.setNewData(appointment);
        appointmentLookup.setPaginationData(page);
        appointmentLookup.hideLoadingOverlay();
        setExportData(appointmentLookup.generateData());
    }

    function initExport() {
        let exportObj = {
            title: mainEl.data("export-popup-title"),
            exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
            exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
            exportMaxLimitLang: mainEl.data("export-max-row-limit")
        };
        exportModal.init(exportObj);
        exportModal.bindExportEvent();
    }

    function setExportData(currentData) {
        exportModal.buildExportBasicURL(generateExportUrl, currentData);
        exportModal.setExportCount(currentData.totalElements);
    }

    initExport();
    setExportData(appointmentLookup.generateData());

    handleCustomDropdownEvents();

    let cancelAppointmentModal = $(render(
        modalHtml, {
            title: 'Cancel Appointment',
            modalDialogClass: 'q-modal-dialog-800',
            leftAlignTitle: true,
            topCloseBtn: true,
            autoHideTop: true,
            body: cancelAppointmentModalBodyHtml,
            footerBtns: `<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn cancel-appointment-btn-on-modal">Cancel Appointment</a>`
        }
    ));

    function renderReasonList() {
        let cancelReasonOptions = (cancelResonList).map((item) => {
            return render(optionTemplateHtml, {
                targetKey: item.cdmValue,
                text: item.cdmMeaning
            });
        });
        return $("#cancel-reason-select").append(cancelReasonOptions.join(''));
    }
    $('body').append(cancelAppointmentModal);
    cancelAppointmentModal.modal(modalOpts);
    renderReasonList();

    function showCancelModal() {
        cancelAppointmentModal.modal('show');
        $("#cancel-reason-select").val("").trigger('change');
		$("#cancel-notes").val("").trigger('change');
        $('.cancel-appointment-btn-on-modal').attr("disabled", true);
    }

    function hideCancelModal() {
        cancelAppointmentModal.modal('hide');
    }

    function shallAllowClick(currentObj) {
        return !($(currentObj).hasClass("disabled"));
    }
    let appointmentIdForCancel;
    $('body').on('click', '.cancel-appointment', function (e) {
        e.preventDefault();
        if (shallAllowClick(this)) {
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            row = $(".data-table-component").dataTable().api().row(parent);
            let appointment = row.data();
            appointmentIdForCancel = appointment.appId;
            showCancelModal();
        }
    });

    let row;
    $('body').on('click', '.edit-appointment', function (e) {
        e.preventDefault();
        if (shallAllowClick(this)) {
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            let rowEdit = $(".data-table-component").dataTable().api().row(parent);
            let appointment = rowEdit.data();
            location.href = `${editAppointmentUrl}&${portletNamespace}appId=${appointment.appId}`;
        }
    });

    $('body').on('click', '.cancel-appointment-btn-on-modal', function (e) {
        e.preventDefault();
        hideCancelModal();
        submitModalFlow.showLoadingModal();
        let cancelReason = $("#cancel-reason-select").val();
        let cancelNotes = $("#cancel-notes").val();
        $.ajax({
            url: cancelAppointmentUrl,
            type: 'POST',
            data: {
                [`${portletNamespace}appId`]: appointmentIdForCancel,
                [`${portletNamespace}cancelReason`]: cancelReason,
                [`${portletNamespace}cancelNotes`]: cancelNotes
            },
            success: function (data) {
                if (data.match("success")) {
                    let d = row.data();
                    d.status = "Cancelled";
                    row.data(d).draw();
                    submitModalFlow.hideAllModals();
                    submitModalFlow.showSuccessModal();
                    setTimeout(function () {
                        submitModalFlow.hideAllModals();
                    }, SUCCESS_MODAL_TIMEOUT);
                } else {
                    submitModalFlow.hideAllModals();
                    submitModalFlow.showFailureModal();
                }
            },
            error: function (data) {
                submitModalFlow.hideAllModals();
            }
        });
    });

    $('body').on('change', '#cancel-reason-select', function(e){
        e.preventDefault();
        $('.cancel-appointment-btn-on-modal').attr("disabled", false);
    });
});


// WEBPACK FOOTER //
// ./src/pages/appointmentForm/lookup.js